import { ShieldCheck } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const UVisa = () => {
  const faqs = [
    {
      question: "What crimes qualify for U visa?",
      answer: "Qualifying crimes include domestic violence, sexual assault, trafficking, kidnapping, stalking, blackmail, witness tampering, and other serious crimes. The crime must have occurred in the U.S. and you must have suffered substantial physical or mental abuse.",
    },
    {
      question: "How long does U visa processing take?",
      answer: "U visa processing typically takes 4-6 years due to annual caps (10,000 per year). However, once you file, you may be eligible for work authorization while waiting. After 3 years with U visa status, you can apply for a green card.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">Immigration Relief for Crime Victims</h2>
        <p className="text-xl text-muted-foreground mb-8">
          If you've been a victim of a serious crime in the United States and have cooperated with law enforcement, you may qualify for a U Visa—a powerful immigration benefit that offers protection, stability, and a path to legal status.
        </p>

        <h3 className="text-2xl font-bold mb-4">U Visa Eligibility</h3>
        <ul className="list-disc pl-6 mb-6">
          <li>Victim of qualifying criminal activity in the U.S.</li>
          <li>Suffered substantial physical or mental abuse</li>
          <li>Have information about the crime</li>
          <li>Cooperated or willing to cooperate with law enforcement</li>
          <li>Obtain certification from law enforcement (Form I-918B)</li>
        </ul>

        <h3 className="text-2xl font-bold mb-4">Benefits of U Visa</h3>
        <ul className="list-disc pl-6 mb-6">
          <li>Legal status for up to 4 years</li>
          <li>Work authorization</li>
          <li>Protection from deportation</li>
          <li>Ability to include family members</li>
          <li>Path to permanent residence after 3 years</li>
        </ul>

        <h3 className="text-2xl font-bold mb-4">Our U Visa Services</h3>
        <p className="mb-8">
          We assist with obtaining law enforcement certification, preparing the U visa petition, documenting the crime and harm suffered, filing derivative petitions for family members, and applying for adjustment of status after 3 years.
        </p>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title="U Visa"
      subtitle="Immigration relief for crime victims who cooperate with law enforcement"
      icon={<ShieldCheck className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default UVisa;
